<div id="locationDetail" class="ya-typography">
  <ya-subheader [hasContent]="false"></ya-subheader>
  <div class="ya-page-content ya-page-content--webshop">
    <ng-container *ngIf="hasData; then pageTemplate else emptyTemplate"></ng-container>
    <ng-template #pageTemplate>
      <div class="location-detail-image-wrapper">
        <div class="aspect-ratio-box">
          <div class="aspect-ratio-box-inside">
            <div class="aspect-ration-img-box">
              <img class="ya_image" [src]="locationDetailViewModel.image_photo" alt="" />
            </div>
          </div>
        </div>
      </div>
      <mat-tab-group mat-stretch-tabs [(selectedIndex)]="matGroupSelectedIndex" (swipeleft)="swipeLeftHandler()"
        (swiperight)="swipeRightHandler()" animationDuration="20ms" class="ya-tab-group">
        <mat-tab>
          <ng-template mat-tab-label>
            <span a11y_Button langkey="phLocationDetail_TabName_Overview"></span>
          </ng-template>
          <div class="location-wrapper">
            <section class="location-detail-content">
              <div class="location-detail-page-content-header ya-detail-page-header">
                <h2>{{locationDetailViewModel.label}}</h2>
                <div class="location-detail-like">
                  <ya-favoritebutton [contentType]="contentType.Location" [likeStatus]="locationDetailViewModel.like"
                    [modelId]="locationDetailViewModel.hyp_cus_nr">
                  </ya-favoritebutton>
                </div>
              </div>
              <div class="location-detail--style location-detail--bg location-detail-mobile-time">
                <mat-expansion-panel (opened)="fullDaysPanelToggle()" (closed)="fullDaysPanelToggle()">
                  <mat-expansion-panel-header tabindex="0" collapsedHeight="*" expandedHeight="*">
                    <mat-panel-title>
                      <div class="location-detail-content-info">
                        <div class="open-time-svg inline-icon" inlineSVG="shop-icons.svg#ya-schedule"></div>
                        <div class="location-detail-content-open-time">
                          <span langkey="phGlobal_OpenTime"></span>

                          <ng-container *ngIf="fullDaysPanelOpened; then expandLessTemplate else expandMoreTemplate">
                          </ng-container>

                          <ng-template #expandMoreTemplate>
                            <div a11y_Button class="inline-icon" inlineSVG="shop-icons.svg#ya-expand_more"></div>
                          </ng-template>
                          <ng-template #expandLessTemplate>
                            <div a11y_Button class="inline-icon" inlineSVG="shop-icons.svg#ya-expand_less"></div>
                          </ng-template>
                        </div>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="location-detail-openday ya-body-1"
                    [class.grid-customised]="locationDetailViewModel.upcomingSpecialDays && locationDetailViewModel.upcomingSpecialDays.length > 0">
                    <ng-container *ngFor="let openday of locationDetailViewModel.openDays; let first = first">
                      <div class="weekday" [class.highlight]="first">{{openday.weekdayToString()}}:</div>
                      <p [class.highlight]="first">{{openday.timesToString()}}</p>
                    </ng-container>
                  </div>
                  <ng-container
                    *ngIf="locationDetailViewModel.upcomingSpecialDays && locationDetailViewModel.upcomingSpecialDays.length > 0">
                    <h2 langkey="phLocationDetail_DeviatingOpeningHours" class="location-detail-specialday"></h2>
                    <div class="location-detail-openday ya-body-1 grid-customised">
                      <ng-container *ngFor="let day of locationDetailViewModel.upcomingSpecialDays">
                        <div class="day" [class.highlight]="day.active">
                          <span>{{day.dateToString()}}.:</span>
                        </div>
                        <p [class.highlight]="day.active">{{day.timesToString()}}</p>
                      </ng-container>
                    </div>
                  </ng-container>
                </mat-expansion-panel>
                <ng-container *ngIf="!fullDaysPanelOpened && locationDetailViewModel.openDays">
                  <div class="location-detail-opentime highlight">
                    <div class="weekday">{{locationDetailViewModel.openDays[0].weekdayToString()}}:</div>
                    <div class="times">{{locationDetailViewModel.openDays[0].timesToString()}}</div>
                  </div>
                </ng-container>
              </div>
              <div class="location-detail-mobile-container">
                <div a11y_Button class="location-detail--style location-detail--bg" (click)="openMapMarker()">
                  <div class="location-detail-content-container location-detail-mobile-content">
                    <div class="location-detail-content-wrapper">
                      <div class="location-detail-content-info">
                        <div class="inline-icon ya-favorite-svg" inlineSVG="shop-icons.svg#ya-hypersoft-standort"></div>
                        <div class="location-detail-pc-content">
                          <span>{{locationDetailViewModel.street}},</span>
                          <span class="location-detail-pc">{{locationDetailViewModel.zip}}
                            {{locationDetailViewModel.location}}</span>
                        </div>
                      </div>
                      <div>
                      </div>
                    </div>
                  </div>
                  <ng-container *ngIf="locationDetailViewModel.hasReservation">
                    <div a11y_Button class="location-detail-content-info" (click)="routeToPath('reservation')">
                      <div class="inline-icon ya-favorite-svg" inlineSVG="shop-icons.svg#ya-reservation"></div>
                      <span langkey="phLocationDetail_Reservation"></span>
                    </div>
                  </ng-container>
                </div>
                <div class="location-detail--info">
                  <div class="location-detail--style location-detail--bg">
                    <ng-container *ngIf="locationDetailViewModel.mail">
                      <div a11y_Button class="location-detail-content-info"
                        (click)="openEMailApp(locationDetailViewModel)">
                        <div class="inline-icon ya-favorite-svg" inlineSVG="shop-icons.svg#ya-mail_outline"></div>
                        <span class="location-detail-content-info-mail">{{locationDetailViewModel.mail}}</span>
                      </div>
                    </ng-container>
                  </div>
                  <div class="location-detail--style location-detail--bg">
                    <ng-container *ngIf="locationDetailViewModel.phone_no">
                      <div a11y_Button class="location-detail-content-info"
                        (click)="onPhoneCallAction(locationDetailViewModel)">
                        <div class="inline-icon ya-favorite-svg" inlineSVG="shop-icons.svg#ya-local_phone"></div>
                        <span>{{locationDetailViewModel.phone_no}}</span>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </section>
            <ng-container *ngIf="locationDetailViewModel.image_map">
              <div class="detail-map map-content">
                <a a11y_Button (click)="openMapMarker()">
                  <div class="aspect-ratio-box">
                    <div class="aspect-ratio-box-inside">
                      <div class="aspect-ration-img-box">
                        <img class="ya_image" [src]="locationDetailViewModel.image_map" alt="" />
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </ng-container>
          </div>
          <ng-container *ngIf="locationDetailViewModel">
            <div class="location-detail-content location-detail-content-full">
              <div class="location-detail--style location-detail--bg">
                <div class="location_detail-detail-impressum">
                  <div class="location_detail-detail-content-wrapper">
                    <div class="list-header_icon">
                      <div class="icon-container">
                        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-standort"></div>
                      </div>
                    </div>
                    <ul>
                      <h2 *ngIf="locationDetailViewModel?.label">
                        {{locationDetailViewModel.label}}
                      </h2>
                      <li *ngIf="locationDetailViewModel?.stnr">
                        <span langkey="phInHouseLocalBasket_ImpressumDialog_stnr"></span>
                        <span class="location_detail-detail-text">{{locationDetailViewModel.stnr}}</span>
                      </li>
                      <li *ngIf="locationDetailViewModel?.ustid">
                        <span langkey="phInHouseLocalBasket_ImpressumDialog_ustid"></span>
                        <span class="location_detail-detail-text">{{locationDetailViewModel.ustid}}</span>
                      </li>
                      <li *ngIf="impressumModelData?.impressumHtml && impressumModelData?.impressumHtml">
                        <div (click)="openLocationImpressumDialog($event)" class="privacyLink">
                          <span langkey="phInHouseLocalBasket_ImpressumDialog"></span>
                        </div>
                      </li>
                    </ul>
                    <ul>
                      <li *ngIf="locationDetailViewModel?.commercial_register">
                        <span langkey="phInHouseLocalBasket_ImpressumDialog_commercial_register"></span>
                        <span class="location_detail-detail-text">{{locationDetailViewModel.commercial_register}}</span>
                      </li>
                      <li *ngIf="locationDetailViewModel?.representative">
                        <span langkey="phInHouseLocalBasket_ImpressumDialog_representative"></span>
                        <span class="location_detail-detail-text">{{locationDetailViewModel.representative}}</span>
                      </li>
                      <li *ngIf="locationDetailViewModel?.local_court">
                        <span langkey="phInHouseLocalBasket_ImpressumDialog_local_court"></span>
                        <span class="location_detail-detail-text">{{locationDetailViewModel.local_court}}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </mat-tab>
        <mat-tab>
          <div class="col2">
            <ng-template mat-tab-label>
              <span a11y_Button langkey="phLocationDetail_TabName_Order"></span>
            </ng-template>
            <ng-container *ngIf=" ordertypes$ | async; let ordertypes">
              <ng-container *ngIf="ordertypes.length > 0; then tabContent else emptyTab"></ng-container>
              <ng-template #tabContent>
                <section class="location-detail-content location-detail-content--servicetab">
                  <div class="location-detail-order-description">
                    <p langkey="phLocationDetail_PlsChooseService_TEXT"></p>
                  </div>

                  <ng-container *ngFor="let ordertype of ordertypes">
                    <div a11y_Button class="choice ya-icon-button service-button" (click)="checkService(ordertype.id)">
                      <div class="icon-container">
                        <div class="inline-icon" inlineSVG="{{ordertype.iconFilename}}"></div>
                      </div>
                      <div class="content-container">
                        <h2 class="title">{{ordertype.label}}</h2>
                        <div class="text content-container--subfont">{{ordertype.description}}</div>
                      </div>
                    </div>
                  </ng-container>

                </section>
              </ng-template>
              <ng-template #emptyTab>
                <ya-emptypage emptyTitle="phEmptyTab_Title" emptyContent="phEmptyTab_Content"></ya-emptypage>
              </ng-template>
            </ng-container>
          </div>

        </mat-tab>
      </mat-tab-group>
    </ng-template>
    <ng-template #emptyTemplate>
      <ya-emptypage></ya-emptypage>
    </ng-template>
  </div>
</div>